/**
 * MarketplaceGate — layout wrapper for the parent marketplace brand.
 *
 * ⚠️ STATUS (2026-07-03): GATE DISABLED.
 *
 * The gate now returns `<Outlet />` unconditionally — UCWonder is fully
 * public. Homesbyli users clicking the cross-brand promo now land on
 * the real UCWonder landing / concierge / experiences pages instead of
 * the Coming Soon placeholder, and any direct visitor to ucwonder.com
 * (once DNS resolves) sees the actual product.
 *
 * The original gate logic is preserved below (commented) so we can
 * re-enable in one line if we ever need a maintenance / re-launch
 * lockout window. `LandingMarketplaceComingSoon` and the allowed-paths
 * list stay in the tree in case we need them back.
 *
 * To RE-ENABLE the gate:
 *   1. Uncomment the `if (brandKey !== 'marketplace') ...` block below
 *   2. Add any paths that should stay reachable to `MARKETPLACE_ALLOWED_PATHS`
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars -- kept for the re-enable path
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars -- kept for the re-enable path
import { useBrand } from './useBrand';
// eslint-disable-next-line no-unused-vars -- kept for the re-enable path
import LandingMarketplaceComingSoon from '../pages/LandingMarketplaceComingSoon';

// Paths that bypass the gate even when the marketplace brand is active.
// Currently unused (gate is fully open) but kept for the re-enable path.
// eslint-disable-next-line no-unused-vars
const MARKETPLACE_ALLOWED_PATHS = new Set([
  '/marketplace-preview',
]);

const MarketplaceGate = () => {
  // Gate is intentionally open — see file header for re-enable steps.
  // ── Re-enable block (uncomment to restore Coming-Soon lockout) ──
  // const { brandKey } = useBrand();
  // const location = useLocation();
  // if (brandKey !== 'marketplace') return <Outlet />;
  // if (MARKETPLACE_ALLOWED_PATHS.has(location.pathname)) return <Outlet />;
  // return <LandingMarketplaceComingSoon />;
  return <Outlet />;
};

export default MarketplaceGate;
